import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Router } from '@angular/router';
import { ReferalFormService } from '../shared/referal-form.service';
import { VendorService } from '../shared/vendor.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { InstructionsComponent } from '../instructions/instructions.component';

@Component({
  selector: 'app-parcticipant-validation',
  templateUrl: './parcticipant-validation.component.html',
  styleUrls: ['./parcticipant-validation.component.css', '../shared/css/common.css']
})
export class ParcticipantValidationComponent implements OnInit {

  formdata: any | null;
  validateParticipantForm = this.validateParticipantFormBuilder.group({});
  validateParticipantFormData: any;
  participantvalidationFormData: any;
  payorkey: number;
  title: string = "";
  instructionText!: string | null;
  isInstruction: boolean = false;

  isformloaded: boolean = false;
  isFormsValid: boolean = false;
  profileMasterTypeKey: any;
  primaryColor?: string = "";

  externalReferallFormData: any;
  isExternalReferral: boolean = false;

  constructor(
    private validateParticipantFormBuilder: FormBuilder,
    private router: Router,
    private validateParticipantService: ReferalFormService,
    private vendorService: VendorService,
    private cdref: ChangeDetectorRef,
    private modalService: NgbModal
  ) {
    this.formdata = JSON.parse(sessionStorage.getItem("activeformdata") ?? "");
    this.validateParticipantFormData = this.formdata.validateParticipant;
    this.payorkey = parseInt(sessionStorage.getItem("payorkey") ?? "0");
    this.externalReferallFormData = this.formdata.extenalReferall;
  }

  ngOnInit(): void {
    if (this.externalReferallFormData.controls.find((x: { name: string; }) => x.name == "isExternalReferal").value === 'Yes') {
      this.isExternalReferral = true;
    }
    else {
      this.isExternalReferral = false;
    }

    this.vendorService.getInvolvedPartiesLookup(this.payorkey).subscribe((result) => {
      let selectedpartyId = this.formdata.witnessDetails.controls.find((x: { name: string; }) => x.name == "involvedType").value;
      let selectedparty = result.find(x => x.Id == selectedpartyId);
      if (selectedparty) {
        this.profileMasterTypeKey = selectedparty.ProfileMasterTypeKey;
      }
    })

    this.vendorService.getRequiredFields(this.payorkey).subscribe((result) => {
      this.vendorService.getLeadPatientsTerm(this.payorkey).subscribe((list: any) => {
        let title = list.find((x: any) => x.Id === result.SelectedPaitentId)?.Title;
        this.title = title;
        this.validateParticipantFormData.controls.find((x: { name: string; }) => x.name === 'vpIsParticipant').label = "Does this referral involve a specific " + this.title + " ?";
        this.validateParticipantFormData.subcontrols.find((x: { name: string; }) => x.name === 'vpIsreferring').label = "Is the " + this.title + " the same person as the witness or external referring party?";
      });

      this.isformloaded = true;
    });

    this.vendorService.getLeadHeaders(this.payorkey).subscribe((result) => {
      this.isInstruction = result.IsInstructionEnbaled;
      let instructionText = result.Instruction;
      instructionText = instructionText.replace('<img ', '<img title="Header" ')
      this.instructionText = instructionText;
    });
    setTimeout(() => {
      if (localStorage.getItem('primaryCssColor') != null && typeof (localStorage.getItem('primaryCssColor')) != 'undefined') {
        const colorFromStorage = localStorage.getItem('primaryCssColor');
        this.primaryColor = colorFromStorage ? colorFromStorage.toString() : '';
        document.documentElement.style.setProperty('--primary-color', this.primaryColor);
      }
    }, 0);
  }

  openInstruction() {
    const result = this.modalService.open(InstructionsComponent, { size: 'lg', ariaLabelledBy: 'Instructions' });
    result.componentInstance.name = this.instructionText;
  }

  validateParticipantDetailsSubmit() {
    if (!(this.validateParticipantForm.invalid && this.validateParticipantForm.get('isExternalReferal')?.value != 'No')) {
      this.formdata.validateParticipant = this.validateParticipantFormData;
      sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
      if(sessionStorage.getItem("isParticipantChanged") == "changed"){
        if (this.validateParticipantForm.get('vpIsParticipant')?.value === 'No') {
          const keys = Object.keys(this.formdata.participantDetails.controls);
          keys.forEach(element => {
            this.formdata.participantDetails.controls[element].value = "";
          });
          sessionStorage.setItem("isParticipantChanged", "first");
          sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
        }
      }else{
        sessionStorage.setItem("isParticipantChanged", "first");
      }

      if (sessionStorage.getItem("isParticipantIsreferringChanged") == "changed") {
        const keys = Object.keys(this.formdata.participantDetails.controls);
        keys.forEach(element => {
          this.formdata.participantDetails.controls[element].value = "";
        });
        sessionStorage.setItem("isParticipantIsreferringChanged", "first");
        sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));
      } else {
        sessionStorage.setItem("isParticipantIsreferringChanged", "first");
      }
      
      if (this.validateParticipantForm.get('vpIsParticipant')?.value !== 'Yes') {
        this.router.navigate(['questions']);
      } else {
        this.router.navigate(['particpant']);
      }
    }
  }

  back() {
    this.formdata.validateParticipant = this.validateParticipantFormData;
    sessionStorage.setItem("activeformdata", JSON.stringify(this.formdata));

    const profileKey = sessionStorage.getItem("selectedProfileMasterTypeKey");

    if (profileKey === "2") {
      this.router.navigate(['witness']);
      return;
    }

    if (this.profileMasterTypeKey === 1) {
      this.router.navigate(['provider']);
    }
    else if (this.profileMasterTypeKey === 2) {
      this.router.navigate(['member']);
    }
    else if (this.profileMasterTypeKey === 3) {
      this.router.navigate(['nonEnumeratedProvider']);
    }
    else if (this.profileMasterTypeKey === 4) {
      this.router.navigate(['nonEnumeratedOrganization']);
    }
    else if (this.profileMasterTypeKey === 5) {
      this.router.navigate(['nonEnumeratedIndividual']);
    }
}


  valueChangeEvent(data: any) {
    if (data.name === 'vpIsParticipant') {
      const keys = Object.keys(this.validateParticipantForm.value);
      keys.forEach(element => {
        if (element !== 'vpIsParticipant') {
          this.validateParticipantForm.removeControl(element);
        }
      });
      this.validateParticipantFormData.subcontrols.find((x: { name: string; }) => x.name === 'vpIsreferring').value="";
    }

    if (data.name === 'vpIsParticipant' && data.value.target.value === 'No') {
      if(sessionStorage.getItem("isParticipantChanged") == "first"){
        sessionStorage.setItem("isParticipantChanged", "changed");
      }
    }
    if (data.name === 'vpIsreferring') {
      this.formdata.participantFilled = false;
      if(sessionStorage.getItem("isParticipantIsreferringChanged") == "first"){
        sessionStorage.setItem("isParticipantIsreferringChanged", "changed");
      }
    }
  }

}
